import React from "react";
import "../style/Hero.css";
import shampoo200 from "../images/200ml_shampoo.png";
import vitalizer from "../images/tonic.png";
import { LuHeart } from "react-icons/lu";

const Hero = () => {
  return (
    <section id="home" className="hero">
      <div className="hero-inner">
        <div className="hero-copy">
          <span className="hero-badge">
            Care Beyond Beauty <LuHeart className="hero-badge-icon" />
          </span>
          <h1 className="hero-heading">
            Healthy roots. Strong hair. Effortless shine.
          </h1>
          <p className="hero-subtext">
            Rammyaa blends time-tested Arnica extract with modern, gentle
            formulations, paraben free, pH balanced and made for every
            member of your family.
          </p>
          <div className="hero-actions">
            <a href="#products" className="btn btn-primary">
              Shop Now
            </a>
            <a href="#why" className="btn btn-outline">
              Why Rammyaa
            </a>
          </div>
        </div>
        <div className="hero-image-wrap">
          <div className="hero-image-card">
            <img
              src={shampoo200}
              alt="Rammyaa Arnica Shampoo 200 ml bottle"
              className="hero-img hero-img-shampoo"
            />
            <img
              src={vitalizer}
              alt="Rammyaa Rosemary Biotin Arnica Hair Vitalizer"
              className="hero-img hero-img-vitalizer"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
